export default __webpack_public_path__ + "static/media/myapps_pink.3b699aa0.svg";